export default __webpack_public_path__ + "static/media/lockIcon.ca0ee726.webp";